/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mail_body-textarea[_ngcontent-%COMP%]{padding-top:15px;padding-left:8px;white-space:pre-wrap;word-break:break-all}.keyword-reject[_ngcontent-%COMP%]{text-align:center;color:var(--warning-color)}.tag-area[_ngcontent-%COMP%]{margin-right:5rem}.show-full-text-button[_ngcontent-%COMP%]{margin-top:1rem}.show-full-text-button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };
